import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';

import auth from './auth';
import keys from './keys';
import verify from './verify';
import xhr from './xhr';

const Reducers = history =>
  combineReducers({
    auth,
    keys,
    verify,
    xhr,
    router: connectRouter(history),
  });

export default Reducers;
